var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-toolbar",
    { attrs: { "md-theme": "brown-white" } },
    [
      _c("h2", { staticClass: "md-title", staticStyle: { flex: "1" } }, [
        _vm._v(_vm._s(_vm.section))
      ]),
      _c(
        "md-subheader",
        [
          _c("span", { staticClass: "account-name" }, [
            _vm._v(_vm._s(_vm.account_name)),
            _vm.impersonate
              ? _c("small", { staticClass: "impersonate" }, [
                  _vm._v("IMPERSONATING"),
                  _c(
                    "button",
                    { staticClass: "btnStop", on: { click: _vm.stop } },
                    [_vm._v("[ STOP ]")]
                  )
                ])
              : _vm._e()
          ]),
          _vm._l(_vm.nav, function(item) {
            return _c(
              "span",
              { staticClass: "breadcrumb-item" },
              [
                _c("span", { staticClass: "breadcrumb-divider" }, [
                  _vm._v("/")
                ]),
                item.route
                  ? _c("router-link", { attrs: { to: { name: item.route } } }, [
                      _vm._v(_vm._s(item.title))
                    ])
                  : _c("span", [_vm._v(_vm._s(item.title))])
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d337116", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d337116","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Breadcrumbs.vue
// module id = 668
// module chunks = 0